import { render, staticRenderFns } from "./club-info-header.vue?vue&type=template&id=0d8532a2&scoped=true"
import script from "./club-info-header.vue?vue&type=script&lang=js"
export * from "./club-info-header.vue?vue&type=script&lang=js"
import style0 from "./club-info-header.vue?vue&type=style&index=0&id=0d8532a2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8532a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8532a2')) {
      api.createRecord('0d8532a2', component.options)
    } else {
      api.reload('0d8532a2', component.options)
    }
    module.hot.accept("./club-info-header.vue?vue&type=template&id=0d8532a2&scoped=true", function () {
      api.rerender('0d8532a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/club-info/club-info-header.vue"
export default component.exports